import DialogTitle from '@mui/material/DialogTitle'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import IconText from '@/app/component/layout/icon-text'

type Props = {
  closeButtonLabel?: string
  disabled?: boolean
  icon?: string | React.ReactNode
  title: React.ReactNode
  onClose: () => void
}

const DialogHeader: React.FC<Props> = ({ closeButtonLabel = 'close', disabled = false, icon, title, onClose }) => {
  return (
    <StyledDialogTitle>
      <TitleContainer>
        <IconText>
          {typeof icon === 'string' ? <Icon>{icon}</Icon> : icon}
          <Typography variant="h6">{title}</Typography>
        </IconText>
        <IconButton aria-label={closeButtonLabel} disabled={disabled} onClick={onClose}>
          <Icon>close</Icon>
        </IconButton>
      </TitleContainer>
    </StyledDialogTitle>
  )
}

const StyledDialogTitle = styled(DialogTitle)({
  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
})

const TitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
})

export default DialogHeader
